import React, { Suspense, useState, useEffect } from "react";
import { CommonUtilities } from '../../commonUtils';
import Modal from 'react-responsive-modal';
import contractServices from "../Contracts/contractServices";
import contactService from "./contactService";
import Pagination from "components/Common/newPagination";

export default function DealsManager(DealsManager: any) {


    const [royaltylistContactAsset, initroyaltylistContactAsset] = useState<any>([]);
    const [royaltylistContractContactAsset, initroyaltylistContractContactAsset] = useState<any>([]);

    const [totalRowsContractsearch, setTotalRowsContractsearch] = useState(0);
    const [totalRowsDealssearch, setTotalRowsDealssearch] = useState(0);
    const [filterManageDeals , setfilterManageDeals] = useState("");
    var payload = {
        searchText: "",
        pageNumber: 1,
        pageSize: 10,
        kontactCode: ""
    }
    var payloadDealssearch= {
        pageNumber: 1,
        pageSize: 10,
        kontactCode: ""
    }
    
    useEffect(() => { 
        if(DealsManager.code.kontactCode){
            Contractsearch();
            Dealssearch();            
        }

    }, []);

    const Contractsearch =()=>{
        
        if(filterManageDeals.length> 0){
            payload.searchText = filterManageDeals;            
        }
        payload.kontactCode = DealsManager.code.kontactCode;
        contactService.royaltylistContactAsset(payload).then((values:any)=>{
            initroyaltylistContactAsset(values);
            setTotalRowsContractsearch( values && values[0] && values[0].totalRows ? values[0].totalRows : 0)
        })
    }

    const Dealssearch =()=>{
        
        payloadDealssearch.kontactCode = DealsManager.code.kontactCode;
        contactService.royaltylistContractContactAsset(payloadDealssearch).then((values:any)=>{
            initroyaltylistContractContactAsset(values);
            setTotalRowsDealssearch( values && values[0] && values[0].totalRows ? values[0].totalRows : 0)
        })
    }

    const removeDealsManager =(e:any)=>{
        contactService.deleteContactAsset(e.contactAssetId).then((res)=>{
            Contractsearch();
            Dealssearch();  
        });
    }

    const saveContactAsset =(e:any)=>{
        var savePayload = {
            assetCode: e.assetCode,
            assetType:  "Contract",
            contactAssetId :  0,
            kontactCode:  DealsManager.code.kontactCode,
            status:  e.status 
        }
        contactService.saveContactAsset(savePayload).then((res)=>{
            Contractsearch();
            Dealssearch();  
        });
    }    

    const handleContractsearch = (e:any) => {
        payload.pageNumber = e.pageNumber;
        payload.pageSize = e.pageSize;
        Contractsearch();
    }

    const handleDealssearch = (e:any) => {
        payloadDealssearch.pageNumber = e.pageNumber;
        payloadDealssearch.pageSize = e.pageSize;
        Dealssearch();
    }

    const closeDealsManager =()=>{
        DealsManager.closeDealsManager();
    }

    return (
        <>
            <Modal open={DealsManager.openDealsManager} onClose={() => closeDealsManager()}>

            <div className="ws-12">
                <div className="box ws-12">
                    <div className="box-header-main">
                        <h2><i className="icon-bar-chart"></i> Contact Details</h2>
                    </div>
                    <div className="box-content">
                        <div className="form-format ws-3">
                            <label className="pts">Contact ID : </label>
                            <div className="label-entries pts mts">
                                <span className="pts">{DealsManager.code.kontactId}</span>
                            </div>
                        </div>

                        <div className="form-format ws-3">
                            <label className="pts">Contact Name : </label>
                            <div className="label-entries pts mts">
                                <span className="pts">{DealsManager.code.kontactName}</span>
                            </div>
                        </div>

                        <div className="form-format ws-3">
                            <label className="pts">Contact Code : </label>
                            <div className="label-entries pts mts">
                                <span className="pts">{DealsManager.code.kontactCode}</span>
                            </div>
                        </div>

                        <div className="form-format ws-3">
                            <label className="pts">Contact Display : </label>
                            <div className="label-entries pts mts">
                                <span className="pts">{DealsManager.code.kontactDisplay}</span>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="box-content ws-12 mts">

                    <div className="ws-6 pr">
                        <div className="box pull-left m0 ws-12">
                            <div className="box-header"> <h2 className="pull-left"><i className="icon-bar-chart"></i> Contract search ({totalRowsContractsearch})</h2> </div>
                            <div className="box-content pm">
                                <div className="ws-12 mb pull-left">
                                    <input type="text" className="pull-left ws-6" value={filterManageDeals} onChange={(e)=>setfilterManageDeals(e.target.value)} placeholder="Filter Contracts"/>

                                    <button className="icon-btn edit btn-xs caret  pull-left" onClick={Contractsearch}> <i className="icon-search"/></button>

                                    <div className="alert alert-info mb mt hide" data-ng-show="contactTypeMsg">Contact Type is required. </div>                                    
                                </div>

                                {royaltylistContactAsset.map((values : any)=>{
                                    return (
                                        <div className="box mb !active">
                                        <div className="ws-12">
                                            <div className="pull-left text-bold ml pm">
                                                <div className="ws-12 pull-left mb"> {values.name} ({values.assetCode}) </div>
                                            </div>
    
                                            <div className="pull-right mt mr mb">
                                                <a className="icon-btn edit pull-right btn-xs" onClick={()=>saveContactAsset(values)}>  <i className="icon-angle-double-right"/> </a>
                                            </div>

                                        </div>
                                    </div>
                                    )

                                })}                            
                                
                                <div className="clearfix mtl">
                                    {
                                        (() => {
                                            if (totalRowsContractsearch && totalRowsContractsearch > 10) {
                                                return  <Pagination onPageChange={handleContractsearch} totalRow={totalRowsContractsearch} />;
                                            }


                                        })()
                                    }
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="ws-6 pls">
                        <div className="box pull-right m0 ws-12">

                            <div className="box-header">
                                <h2 ><i className="icon-bar-chart"></i> Deals ({totalRowsDealssearch})</h2>
                            </div>
                            <div className="box-content pm">

                                {royaltylistContractContactAsset?.map((values :any)=> {
                                    return (

                                        <div className="box mb">
                                            <div className="ws-12">
                                                <div className="pull-left text-bold ml pm">
                                                    <div className="ws-12 pull-left mb"> {values.name}({values.assetCode}) </div>
                                                </div>

                                                <div className="pull-right mt mr mb">
                                                    <a className="icon-btn delete pull-right btn-xs" onClick={()=>removeDealsManager(values)}> <i className="icon-angle-double-left"></i></a>
                                                </div>

                                            </div>

                                        </div> 
                                    )
                                })}

                                <div className="clearfix mtl">
                                    {
                                        (() => {
                                            if (totalRowsDealssearch && totalRowsDealssearch > 10) {
                                                return  <Pagination onPageChange={handleDealssearch} totalRow={totalRowsDealssearch} />;
                                            }

                                        })()
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="box-footer mts ws-12">
                    <button className="icon-btn delete pull-right" onClick={() => closeDealsManager()}>Close</button>
                </div>
            </div>
            </Modal>
        </>

    )
}